<script setup>
import { ref, toRefs, onMounted } from 'vue'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseSelect from '@/src/vueComponent/BaseSelect.vue'
import { ClearOutlined, SearchOutlined } from '@ant-design/icons-vue'

const props = defineProps({
  companyType: {
    type: String
  }
})

const { companyType } = toRefs(props)

const determinePartnerUrl = () => {
  if (companyType.value === 'Customer') {
    return '/customer/quality_feedbacks'
  } else if (companyType.value === 'Supplier') {
    return '/supplier/quality_feedbacks'
  }
}

const searchInfo = ref({
  lot_no: '',
  category: ''
})

const categoryList = ref(
  Object.entries(I18n.t('enumerize.quality_feedback.state')).map(([value, label]) => ({
    value,
    label
  }))
)
categoryList.value.unshift({ value: 'all', label: '全部' }) // Add 'all'

onMounted(() => {
  const searchParams = new URLSearchParams(window.location.search)
  searchInfo.value.lot_no = searchParams.get('lot_no')
  searchInfo.value.category = searchParams.get('category')

  if (searchInfo.value.category === null) {
    searchInfo.value.category = 'all'
  }
})
</script>

<template>
  <form
    class="min-w-[248px] p-4"
    :action="determinePartnerUrl()"
    accept-charset="UTF-8"
    method="get"
  >
    <div class="mb-2">
      <BaseTextInput
        :label="'批號／料號'"
        :name="'lot_no'"
        v-model="searchInfo.lot_no"
      ></BaseTextInput>
    </div>
    <div class="mb-2">
      <BaseSelect
        :label="'類別'"
        :name="'category'"
        :optionList="categoryList"
        :optionsSelected="searchInfo.category"
        @select="searchInfo.category = $event"
      />
    </div>
    <div class="mb-2 flex justify-between gap-3 py-3">
      <a :href="determinePartnerUrl()" class="btn btn-ghost text-xl">
        <ClearOutlined />
        清空
      </a>
      <button
        type="submit"
        class="block flex-1 rounded-md border-scp-royal-blue bg-scp-royal-blue p-3 text-center text-xl font-semibold text-white hover:bg-blue-800"
      >
        <SearchOutlined />
        查詢
      </button>
    </div>
  </form>
</template>
